import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./UpcomingEvents.css";

import dateIcon from "./assets/svg/date.svg";
import locationIcon from "./assets/svg/location.svg";
import arrowIcon from "./assets/svg/arrow.svg";
import defaultImage from "./assets/image.png";

const UpcomingEvents = () => {
  const [events, setEvents] = useState([]);

  const location = useLocation();
  const isEventDetailsPage = location.pathname.startsWith("/events/");

  useEffect(() => {
    fetch("https://beszeljegyesulet.hu/wp/wp-json/wp/v2/events")
      .then((res) => res.json())
      .then((data) => setEvents(data))
      .catch((err) => console.error("Hiba az események betöltésekor:", err));
  }, []);

  const formatEventDate = (rawDate) => {
    if (!rawDate) return "Dátum nem elérhető";

    const match = rawDate.match(
      /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/
    );

    if (!match) return rawDate;

    const [_, year, month, day] = match;

    const dateObj = new Date(year, month - 1, day);

    let formatted = dateObj.toLocaleDateString("hu-HU", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    return formatted.charAt(0).toLowerCase() + formatted.slice(1);
  };

  return (
    <section className="upcoming-events">

      {/* hide this ONLY on event details page */}
      {!isEventDetailsPage && (
        <h2 className="title-sm">Közelgő Eseményeink</h2>
      )}

      {events.length === 0 ? (
        <p>Betöltés...</p>
      ) : (
        <div className="events-grid">
          {events.map((event) => {
            const featured = event.featured_image_url || defaultImage;
            const formattedDate = formatEventDate(event.acf?.event_date);

            return (
              <div className="event-card" key={event.id}>
                <div className="event-image-wrap">
                  <img
                    src={featured}
                    alt={event.title.rendered}
                    className="event-image"
                  />
                </div>

                <div className="upcomingevent-content">
                  <div className="event-meta">
                    {event.acf?.event_date && (
                      <div className="meta-item">
                        <div className="icon">
                          <img src={dateIcon} alt="date" />
                        </div>
                        <span>
                          <b>{formattedDate}</b>
                        </span>
                      </div>
                    )}

                    {event.acf?.event_location && (
                      <div className="meta-item">
                        <div className="icon">
                          <img src={locationIcon} alt="location" />
                        </div>
                        <span>
                          <b>{event.acf.event_location}</b>
                        </span>
                      </div>
                    )}
                  </div>

                  <h3
                    className="heading-sm"
                    dangerouslySetInnerHTML={{ __html: event.title.rendered }}
                  ></h3>

                  <p
                    className="body-sm"
                    dangerouslySetInnerHTML={{
                      __html:
                        event.excerpt?.rendered
                          ?.replace(/<[^>]+>/g, "")
                          ?.substring(0, 160) + "...",
                    }}
                  ></p>

                  <div className="event-buttons">
                    <Link to={`/events/${event.slug}`} className="event-link">
                      Részletek{" "}
                      <img
                        src={arrowIcon}
                        alt="nyíl ikon"
                        className="arrow-icon"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default UpcomingEvents;
